export enum Onboardings {
  HOME = 'HOME',
  USUARIO_EDICAO = 'USUARIO_EDICAO',
  GRUPO_USUARIO = 'GRUPO_USUARIO'
}
